/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersTenantContractResponseDto } from '../../models/users-tenant-contract-response-dto';

export interface TenantContractControllerFindOne$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
}

export function tenantContractControllerFindOne(http: HttpClient, rootUrl: string, params: TenantContractControllerFindOne$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantContractResponseDto>> {
  const rb = new UsersRequestBuilder(rootUrl, tenantContractControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<UsersTenantContractResponseDto>;
    })
  );
}

tenantContractControllerFindOne.PATH = '/o2-users/tenants/contract/{tenant}';
